import Router from './Router';
import { Notification, PageLoading } from './widgets';
import { Helmet } from 'react-helmet';
import { buildStyle } from './widgets/Shape';
import { ShapeType } from './types';

const App = (): JSX.Element => {
  const sty = buildStyle({ shape: ShapeType.star_1, size: 36, margin: 2 });
  return (
    <>
      <Helmet>
        <style>{`*{${sty}}`}</style>
      </Helmet>
      <Router />
      <Notification />
      <PageLoading />
    </>
  );
};

export default App;
